$(function () {
  try {
    const form = $('.userform')
    const submitBtn = $('input[type="submit"]')

    const inputClass = 'js-hidden-timer-field'

    const hiddenField = $(form).find(`.${inputClass}`)

    const timeOnLoad = new Date()

    $(submitBtn).on('click', function () {
      const timeOnSubmit = new Date()
      const msToComplete = timeOnSubmit - timeOnLoad
      let timeToComplete = msToComplete / 1000
      timeToComplete = secondsToTime(timeToComplete)
      $(hiddenField).val(timeToComplete)
    })

    function secondsToTime(e) {
      const h = Math.floor(e / 3600),
        m = Math.floor((e % 3600) / 60),
        s = Math.floor(e % 60)

      let result = h ? h + 'h ' : ''
      result = m ? result + m + 'm ' : result
      result = s ? result + s + 's' : result

      return result
    }
  } catch (error) {
    console.error(error)
  }
})
